<template>
  <div
    class="standard-switch"
    >
    <div
      class="standard-switch-background"
      :style="`
        ${value?'background-color: #66BB6A;':''}
        ${disabled?'cursor: default;':''}
      `"
      @click="!disabled?$emit('changeValue'):''"
      >
      <div
        class="standard-switch-circle"
        :style="value?'margin-left: 18.5px':''"
        >
        <div v-if="icon_class" :style="icon_style" :class="icon_class" />
        <v-icon
          v-if="icon"
          small
          color="not-primary"
          >
          {{icon}}
        </v-icon>
        <TIcon
          v-if="ticon"
          small
          color="not-primary"
          :name="ticon"
        />
      </div>
    </div>
    <TText :value="label" />
  </div>
</template>
<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';

  export default {
    props: ['value', 'label', 'icon', 'ticon', 'disabled', 'icon_class', 'icon_style'],

    components: {
      TIcon,
    },
  }
</script>
<style>
  .standard-switch {
    display: flex;
    align-items: center;
  }
  .standard-switch-background {
    height: 14px;
    width: 36px;
    border-radius: 8px;
    margin: 3.5px;
    flex-shrink: 0;
    background-color: var(--v-color-1-5-base);
    /* background-color: rgba(255,255,255, 0.3); */
    overflow: visible;
    transition: background-color 0.1s ease-in-out;
    cursor: pointer;
  }
  .standard-switch-circle {
    display: flex;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    transform: translate(0, -3px);
    background-color: var(--v-primary-base);
    opacity: 0.9;
    /* background-color: rgba(255,255,255, 0.9); */
    transition: margin-left 0.1s ease-in-out;
    justify-content: center;
    align-items: center;
  }

</style>
